import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import Alert from '../../../module/alert/Alert'
import { alertActions, manageActions } from '../../../store/actions'

/** 초대메일 재발송
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export const SendInvitEmailPopup = (props) => {
  const [state, setState] = useState({})
  const [users, setUsers] = useState([])

  useEffect(() => {
    setUsers(props.users)
  }, [])

  useEffect(() => {
    setState({
      ...state,
      targetList: props.checkedUsers,
    })
  }, [props.checkedUsers])

  useEffect(() => {
    if (props.isSend) {
      // 전송 성공시
      props.success({
        title: '전송성공',
        message: '전송되었습니다.',
        params: {
          type: 'SUCCESS',
          callback: () => {
            localStorage.setItem('invtTab', '2')
            window.location.reload()
          },
        },
      })
    } else {
      if (props.errorMessage) {
        // 전송 실패시
        props.success({
          title: '전송실패',
          message: '전송이 실패하었습니다.\n' + props.errorMessage,
          params: {
            type: 'ERROR',
            callback: () => {
              localStorage.setItem('invtTab', '2')
              window.location.reload()
            },
          },
        })
      }
    }
  }, [props.isSend])

  const handleChange = (e) => {
    const { name, value } = e.target
    setState({
      ...state,
      [name]: value,
    })
  }

  let style = {
    backgroundColor: 'rgb(0, 0, 0)',
    position: 'fixed',
    inset: '0px',
    opacity: '0.6',
    zIndex: '997',
  }

  let styleModal = {
    position: 'absolute',
    display: 'block',
    opacity: '1',
    zIndex: '998',
  }

  function removeChecked(invtSno) {
    const changedList = state.targetList.filter((user) => user.invtSno !== invtSno.toString())

    setState({
      ...state,
      targetList: changedList,
    })

    let arr = [...users]

    arr.forEach((user) => {
      if (user.invtSno === invtSno) {
        user.checked = false
      }
    })

    setUsers(arr)
  }

  const sendEmail = () => {
    let contents = {
      trnsmisMsg: state.trnsmisMsg,
      groupCode: props.groupCode,
      targetList: [],
    }

    if (state.targetList.length === 0) {
      props.error({
        title: '전송불가',
        message: '이메일을 전송할 고객이 없습니다. 확인해주세요.',
      })

      props.close()
      return
    }

    state.targetList.forEach((user) => {
      contents.targetList.push(JSON.parse(user).invtSno)
    })

    props.insertInvtEmail(contents)
  }

  return (
    <>
      <div style={style}></div>
      <div className="modal-overlay" style={styleModal}>
        <div className="modal w500">
          <div className="modal-head">
            <h2>이메일 발송</h2>
          </div>
          <div className="modal-cont">
            <dl className="dl-form">
              <dt>받는사람</dt>
              <dd>
                <div className="receiver-group">
                  {users.map(
                    (user, index) =>
                      user.checked && (
                        <span key={user?.invtSno ? user?.invtSno : index}>
                          {user.email}{' '}
                          <button type="button" onClick={() => removeChecked(user.invtSno)}>
                            삭제
                          </button>
                        </span>
                      ),
                  )}
                </div>
              </dd>
              <dt>메시지</dt>
              <dd>
                <textarea id="trnsmisMsg" name="trnsmisMsg" placeholder="내용을 입력해주세요." defaultValue={''} onChange={handleChange} />
              </dd>
            </dl>
          </div>
          <div className="modal-foot">
            <a href="#" className="btn-primary" onClick={sendEmail}>
              보내기
            </a>
          </div>
          <button
            onClick={() => {
              props.close()
            }}
            type="button"
            className="modal-close b-close"
          >
            창닫기
          </button>
        </div>
      </div>

      {/* <Alert /> */}
    </>
  )
}

const mapStateToProps = (state) => ({
  isSend: state.manage?.isSend,
  errorMessage: state.manage.errorMessage,
})

const mapDispatchToProps = {
  insertInvtEmail: manageActions.insertInvtEmail,
  error: alertActions.error,
  success: alertActions.success,
}

export default connect(mapStateToProps, mapDispatchToProps)(SendInvitEmailPopup)
